import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const { defineMultiStyleConfig: r, definePartsStyle: o } = e([
  "container",
  "header",
  "body"
]), a = r({
  baseStyle: {
    container: {
      p: "4",
      borderWidth: "1px",
      borderRadius: "lg",
      borderColor: "gray.200",
      bg: "white"
    },
    header: {
      pb: 3
    },
    body: {}
  },
  variants: {},
  defaultProps: {}
});
export {
  a as default
};
